/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Dimmer, Loader } from '@mairistem/composants';
import { request } from '@mairistem/tools';

import { useProduitDomaineStore } from '@/zustand';
import { getProduitDomaine } from '@/routes';
import type { Domaine, Produit, ProduitDomaine } from '@/types';

interface ProduitDomaineZustandProviderProps {
  children: React.ReactNode;
}
interface ResponseType {
  produitDomaine: ProduitDomaine;
  domaine: Domaine;
  produit: Produit;
}

const ProduitDomaineZustandProvider = (
  props: ProduitDomaineZustandProviderProps,
) => {
  const { children } = props;

  const setProduitDomaine = useProduitDomaineStore(
    (state) => state.setProduitDomaine,
  );
  const produitDomaine = useProduitDomaineStore(
    (state) => state.produitDomaine,
  );
  const setDomaine = useProduitDomaineStore((state) => state.setDomaine);
  const domaine = useProduitDomaineStore((state) => state.domaine);
  const setProduit = useProduitDomaineStore((state) => state.setProduit);
  const produit = useProduitDomaineStore((state) => state.produit);

  React.useEffect(() => {
    if (_.isNil(produitDomaine)) {
      request.get(getProduitDomaine()).then((response: ResponseType) => {
        const { produitDomaine: pD, domaine: d, produit: p } = response;
        setProduitDomaine(pD);
        setDomaine(d);
        setProduit(p);
      });
    }
  }, [produitDomaine, setDomaine, setProduit, setProduitDomaine]);

  // Ajoute le header X-Produit-Domaine aux requêtes
  React.useEffect(() => {
    const xProduitDomaine = produitDomaine?.identifiant;
    const xDomaine = domaine?.identifiant;
    const xProduit = produit?.identifiant;

    const interceptor = request.interceptors.request.use((config) => {
      config.headers['X-Produit-Domaine'] = xProduitDomaine;
      config.headers['X-Domaine'] = xDomaine;
      config.headers['X-Produit'] = xProduit;

      return config;
    });

    return () => {
      request.interceptors.request.eject(interceptor);
    };
  }, [produitDomaine, domaine, produit]);

  return (
    <>
      {children}
      <Dimmer active={_.isNil(produit)} inverted>
        <Loader indeterminate />
      </Dimmer>
    </>
  );
};

export default ProduitDomaineZustandProvider;
